var jade = require("D:\\Jenkins670\\workspace\\D_PIPELINE_release_661166.5.70.0\\JAVA\\ui\\group_ui\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"renewal-panel\" class=\"renewal-panel\"><div class=\"renewals-content\"><h5 data-i18n=\"renewalsPanel.header\"></h5><p data-i18n=\"renewalsPanel.text\"> </p></div><a href=\"/myvhi/online-renewals\"><button id=\"renewal-login-btn\" data-i18n=\"renewalsPanel.button\" class=\"renewal-login-btn\"></button></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/main/jade/templates/landing/renewalsPanel.jade
// module id = edcJ
// module chunks = 14